<template>
    <div id="app" style="height: 100vh">
        <vue-snotify/>
        <router-view/>
        <AppSnackbar/>
    </div>
</template>

<script>
import AppSnackbar from './components/shared/AppSnackbar'

export default {
    components: {AppSnackbar},
    methods: {
        onlineNotify() {
            this.$snackbar.show({
                type: 'SUCCESS',
                text: 'We\'re back online',
                caption: 'Now go and do some great work',
                withClose: true,
                duration: 100000
            })
        },
        offlineNotify() {
            this.$snackbar.show({
                type: 'WARNING',
                text: 'You have connection issues.',
                caption: 'You can still browse around <br> while we are trying to reconnect.',
                withClose: true,
                duration: 60000
            })
        }
    },
    created() {
        window.addEventListener('online', this.onlineNotify)
        window.addEventListener('offline', this.offlineNotify)
    }
}
</script>

<style lang="scss">
:root {
    //--color-sf-primary: 139, 34, 148 !important;
}
</style>
